/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compress_Aria_LabelInputs */

const en_compress_aria_label = /** @type {(inputs: Compress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compress text in selected events`)
};

const fr_compress_aria_label = /** @type {(inputs: Compress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compresser le texte dans les evenements selectionnes`)
};

const de_compress_aria_label = /** @type {(inputs: Compress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text in ausgewählten Ereignissen komprimieren`)
};

const it_compress_aria_label = /** @type {(inputs: Compress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimi il testo negli eventi selezionati`)
};

const ru_compress_aria_label = /** @type {(inputs: Compress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сжать текст в выбранных событиях`)
};

const es_compress_aria_label = /** @type {(inputs: Compress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimir texto en eventos seleccionados`)
};

const zh_cn2_compress_aria_label = /** @type {(inputs: Compress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`压缩选定事件中的文本`)
};

const ja_compress_aria_label = /** @type {(inputs: Compress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントのテキストを圧縮する`)
};

const hi_compress_aria_label = /** @type {(inputs: Compress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित घटनाओं में टेक्स्ट को संपीड़ित करें`)
};

const pt_pt2_compress_aria_label = /** @type {(inputs: Compress_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimir texto em eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Compress text in selected events" |
*
* @param {Compress_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compress_aria_label = /** @type {((inputs?: Compress_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compress_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compress_aria_label(inputs)
	if (locale === "de") return de_compress_aria_label(inputs)
	if (locale === "it") return it_compress_aria_label(inputs)
	if (locale === "ru") return ru_compress_aria_label(inputs)
	if (locale === "es") return es_compress_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_compress_aria_label(inputs)
	if (locale === "ja") return ja_compress_aria_label(inputs)
	if (locale === "hi") return hi_compress_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_compress_aria_label(inputs)
	return en_compress_aria_label(inputs)
});